export default __webpack_public_path__ + "static/media/ResumeKinuthiaWachira-Ai-Automation.53405f19.pdf";